import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "build__icon-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "build__icon-main" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "16",
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "build__likes-svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.62064 2.29822C9.71563 2.40892 9.85422 2.47262 10.0001 2.47262C10.146 2.47262 10.2846 2.40892 10.3795 2.29822C12.042 0.360759 14.697 -0.164272 16.7433 1.53117C18.8279 3.25825 19.0829 6.18754 17.4711 8.25512C16.761 9.16591 15.3047 10.6111 13.8175 12.0104C12.3398 13.4007 10.8626 14.7173 10.1329 15.3615C10.0911 15.3983 10.0585 15.4271 10.0298 15.4516C10.0158 15.4637 10.004 15.4736 9.99388 15.4818C9.96318 15.4567 9.92162 15.4203 9.85502 15.3615L9.85497 15.3615C9.12523 14.7173 7.64801 13.4007 6.17037 12.0104C4.68313 10.6111 3.22682 9.16591 2.51676 8.25513C0.90935 6.19323 1.19206 3.2793 3.24966 1.5268L2.92546 1.14615L3.24966 1.5268C5.25246 -0.179029 7.95452 0.35653 9.62064 2.29822Z",
      fill: "#a5a5a5",
      stroke: "#a5a5a5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = { class: "build__likes-amount" }
const _hoisted_4 = {
  key: 0,
  class: "tooltip-anchor"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Видна всем пользователям", -1)
const _hoisted_6 = {
  key: 1,
  class: "tooltip-anchor"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Видна только вам", -1)
const _hoisted_8 = {
  key: 2,
  class: "tooltip-anchor"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "Сборка является копией", -1)
const _hoisted_10 = {
  class: "build__button",
  style: {"cursor":"default"}
}
const _hoisted_11 = { class: "tooltip-anchor" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Удалить", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_animated_like_entity = _resolveComponent("animated-like-entity")!
  const _component_TooltipComponent = _resolveComponent("TooltipComponent")!
  const _component_IconGlobe = _resolveComponent("IconGlobe")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_IconEyeSlash = _resolveComponent("IconEyeSlash")!
  const _component_IconCopy = _resolveComponent("IconCopy")!
  const _component_IconTrash = _resolveComponent("IconTrash")!
  const _component_DialogComponent = _resolveComponent("DialogComponent")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "build__buttons-group",
      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("button", {
        class: _normalizeClass(["build__likes-block", {
				active: _ctx.isLikedByCurrentUser,
				clickable: !_ctx.isUserAnAuthor(),
			}]),
        style: _normalizeStyle({
				cursor: _ctx.isUserAnAuthor() ? 'default' : 'pointer',
			}),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLikeButton && _ctx.handleLikeButton(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.animatedHeartsAmount, (item) => {
            return (_openBlock(), _createBlock(_component_animated_like_entity, { key: item }))
          }), 128))
        ]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.localLikesAmount), 1)
      ], 6),
      (!_ctx.isPreview)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.data.isPublic)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_TooltipComponent, {
                    direction: 'left',
                    width: 22
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _withDirectives((_openBlock(), _createElementBlock("button", {
                    class: "build__button",
                    style: _normalizeStyle({
						cursor: _ctx.isUserAnAuthor() ? 'pointer' : 'default',
					}),
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleVisibilitySwitchButton && _ctx.handleVisibilitySwitchButton(...args)))
                  }, [
                    _createVNode(_component_IconBase, { iconColor: '#a5a5a5' }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconGlobe)
                      ]),
                      _: 1
                    })
                  ], 4)), [
                    [_directive_ripple]
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_TooltipComponent, {
                    direction: 'left',
                    width: 22
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }),
                  _withDirectives((_openBlock(), _createElementBlock("button", {
                    class: "build__button",
                    style: _normalizeStyle({
						cursor: _ctx.isUserAnAuthor() && !_ctx.data.isCloned ? 'pointer' : 'default',
					}),
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleVisibilitySwitchButton && _ctx.handleVisibilitySwitchButton(...args)))
                  }, [
                    _createVNode(_component_IconBase, { iconColor: '#a5a5a5' }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconEyeSlash)
                      ]),
                      _: 1
                    })
                  ], 4)), [
                    [_directive_ripple]
                  ])
                ])),
            (_ctx.data.isCloned)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_TooltipComponent, {
                    direction: 'left',
                    width: 22
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }),
                  _createElementVNode("button", _hoisted_10, [
                    _createVNode(_component_IconBase, { iconColor: '#a5a5a5' }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconCopy)
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.isPreview)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "build__buttons-group",
          onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_TooltipComponent, {
              direction: 'left',
              width: 10
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "build__button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$store.state.dialog.isDeletingBuild = true))
            }, [
              _createVNode(_component_IconBase, { iconColor: '#a5a5a5' }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconTrash)
                ]),
                _: 1
              })
            ])), [
              [_directive_ripple]
            ])
          ]),
          (_ctx.$store.state.dialog.isDeletingBuild)
            ? (_openBlock(), _createBlock(_component_DialogComponent, {
                key: 0,
                dialogName: 'isDeletingBuild',
                yes: { text: 'Удалить', type: 'primary' },
                no: { text: 'Отмена', type: 'tertiary' },
                onConfirm: _ctx.deleteBuild
              }, {
                title: _withCtx(() => [
                  _createTextVNode("Удалить сборку?")
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" Это действие удалит сборку "),
                  _createElementVNode("span", null, _toDisplayString(_ctx.data.name), 1),
                  _createTextVNode(". ")
                ]),
                _: 1
              }, 8, ["onConfirm"]))
            : _createCommentVNode("", true),
          (_ctx.$store.state.dialog.isSwitchingBuildVisibility)
            ? (_openBlock(), _createBlock(_component_DialogComponent, {
                key: 1,
                dialogName: 'isSwitchingBuildVisibility',
                yes: { text: 'Переключить', type: 'primary' },
                no: { text: 'Отмена', type: 'tertiary' },
                onConfirm: _ctx.switchBuildVisibility
              }, {
                title: _withCtx(() => [
                  _createTextVNode("Переключить видимость?")
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" Это действие переключит видимость сборки "),
                  _createElementVNode("span", null, _toDisplayString(_ctx.data.name), 1),
                  _createTextVNode(". ")
                ]),
                _: 1
              }, 8, ["onConfirm"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}